import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import {
  academydeactive,
  academydetail,
  academylist,
} from "../../../services/admin";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Col, Modal, Row } from "react-bootstrap";
import { resaonlist } from "../../../services/master";

export const Academylist = () => {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const [rlist, setRList] = useState([]);
  const [rrea, setRRea] = useState("");
  const [rid, setRID] = useState("");
  const [ractive, setRActive] = useState("");

  const [lpath, setLPath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const columnDefs = [
    {
      headerName: "Action",
      field: "id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="btn-sm btn-success"
              onClick={() =>
                navigate("/settings/academydetail/" + params.value)
              }
            >
              <i className="fa fa-edit"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Status",
      field: "active",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onChange={() => handleSwitch(params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },

    {
      headerName: "Logo",
      field: "logo",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <img
            style={{ width: "35px", height: "35px" }}
            src={lpath + params.value}
          />
        );
      },
    },
    {
      headerName: "Academy",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Code",
      field: "code",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Email",
      field: "email",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Address",
      field: "address",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Area",
      field: "area",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const [show, setShow] = useState(false);
  function handleSwitch(list) {
    if (list.value === 1) {
      Swal.fire({
        text: "Are you sure want to Inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Inactive",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setRRea("");
          academydetail(list.data.id).then((res) => {
            if (res.status === true && res.data.details !== null) {
              if (res.data.details.deactive_reason !== null) {
                setRRea(res.data.details.deactive_reason);
              }
            }
          });
          setRActive(0);
          setRID(list.data.id);
          setShow(true);
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Active?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Active",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setRRea("");
          academydetail(list.data.id).then((res) => {
            if (res.status === true && res.data.details !== null) {
              if (res.data.details.deactive_reason !== null) {
                setRRea(res.data.details.deactive_reason);
              }
            }
          });
          setRActive(1);
          setRID(list.data.id);
          setShow(true);
        }
      });
    }
  }

  useEffect(() => {
    funlist([]);
    resaonlist().then((res) => {
      if (res.status === true) {
        const rdata = res.data.filter((item) => item.is_delete == 1);
        if(rdata !== undefined){
          setRList(rdata);

        }
      }
    });
  }, []);

  function funlist() {
    setFilterProduct([]);
    academylist().then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data.details);
        setLPath(res.data.path);
      }
    });
  }

  function Submitreject(e) {
    e.preventDefault();
    if (rrea !== "") {
      const temp = new FormData();
      temp.append("id", rid);
      temp.append("deactive_reason", rrea);
      temp.append("active", ractive);

      academydeactive(temp).then((response) => {
        if (response.status === true) {
          setRRea("");
          setRID("");
          setShow(false);
          funlist();
        }
      });
    } else {
      setErrorMessage("Please Select Reason");
    }
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">All Academy</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Academy</a>
          </li>

          <li className="breadcrumb-item active" aria-current="page">
            All Academy
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show}>
        <Modal.Header>
          <h4>Add Reason</h4>
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Reason <span className="text-danger"> *</span>
                </label>
              </div>
              <div className="form-group">
                <select
                  className="default-select  form-control wide"
                  value={rrea}
                  onChange={(e) => setRRea(e.target.value)}
                >
                  <option value="" disabled>
                    Select Reason
                  </option>
                  {rlist.map((list) => {
                    return (
                      <option key={list.id} value={list.id}>
                        {list.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Col>

            {errorMessage !== "" && (
              <span className="text-danger">{errorMessage}</span>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <a
            onClick={Submitreject}
            className="btn btn-next btn-success"
            style={{ float: "right" }}
          >
            Submit
          </a>

          <a
            className="btn btn-next btn-secondary"
            style={{ float: "right" }}
            onClick={() => setShow(false)}
          >
            Close
          </a>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
